/*
  File name: deadline.js
    Program Description:
    - This file uses the baseUrl method and the specified functions inside the
    rest file in order to send requests from the web application to the server.
    - This file is focused on the requests related to the deadline feature
*/

import { baseUrl } from '@/settings'
import { get } from '@/utils/rest'

const deadline = {
  getDeadline: () => get(`${baseUrl}/deadline`)
}

export default deadline
